
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCurrencyGrid extends Serenity.EntityGrid<PsCurrencyRow, any> {
        protected getColumnsKey() { return PsCurrencyColumns.columnsKey; }
        protected getDialogType() { return PsCurrencyDialog; }
        protected getIdProperty() { return PsCurrencyRow.idProperty; }
        protected getInsertPermission() { return PsCurrencyRow.insertPermission; }
        protected getLocalTextPrefix() { return PsCurrencyRow.localTextPrefix; }
        protected getService() { return PsCurrencyService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this
            });

            return this.slickGrid;
        }
    }
}